export default __webpack_public_path__ + "static/media/RedDot.fce75049.svg";